import { takeLatest, put, call } from 'redux-saga/effects'

import {
  PROVIDER_SUBMIT_REFERRAL_REQUEST,
  PROVIDER_SUBMIT_REFERRAL_SUCCESS,
  PROVIDER_SUBMIT_REFERRAL_FAILURE,
} from '../constants/constant.action'
import { api } from '../services'

function* getSubmitReferralProviderSaga(action) {
  try {
    const result = yield call(api.getSubmitReferralProvider, action.payload)
    yield put({ type: PROVIDER_SUBMIT_REFERRAL_SUCCESS, payload: result })
  } catch (error) {
    yield put({ type: PROVIDER_SUBMIT_REFERRAL_FAILURE, error })
  }
}

export function* submitReferralProviderWatcherSaga() {
  yield takeLatest(
    PROVIDER_SUBMIT_REFERRAL_REQUEST,
    getSubmitReferralProviderSaga
  )
}
